import { now, parseAbsolute, ZonedDateTime } from '@internationalized/date';
import moment, { getActiveTimeZone } from '../../../common/Moment';
import { head } from 'lodash';
import { NOW } from '../../../discovery/filter/Filter';
import { Moment } from 'moment';

export const toTimeAgnosticMoment = (datetime: string): Moment => {
  // make datetime agnostic of time
  const _withoutTimeFormat = head(datetime.split('T'));
  const _moment = moment.utc(_withoutTimeFormat);

  return _moment.tz(getActiveTimeZone(), true).startOf('day');
};

export const toDateValue = (datetime: string): ZonedDateTime => {
  const _moment = toMomentDate(datetime);

  const iso8601Str = momentToIso8601(_moment);

  return parseAbsolute(iso8601Str, getActiveTimeZone());
};

export const toMomentDate = (datetime: string) => {
  const _moment = toTimeAgnosticMoment(datetime);

  return _moment.startOf('day');
};

export const momentToIso8601 = (date: Moment) => date.format(moment.ISO8601);

export const toIso8601 = (zonedDateTime: ZonedDateTime, end = false) => {
  const momentDate = toTimeAgnosticMoment(zonedDateTime.toLocaleString());

  end && momentDate.endOf('day');

  return momentToIso8601(momentDate);
};

export const nowOrSpecifiedDate = (
  maybeNowOrDate: string = NOW,
): ZonedDateTime =>
  maybeNowOrDate === NOW ? defaultDate() : toDateValue(maybeNowOrDate);

export const defaultDate = () =>
  now(getActiveTimeZone()).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
